<template>
  <header class="header" :class="{ 'scrolled': scrolled }">
    <div class="container header-container">
      <div class="logo">
        <span class="logo-text"></span>
      </div>
      <nav class="nav">
        <ul>
          <li><a href="#download">下载</a></li>
          <li><a href="#about">关于</a></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      scrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 50) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    }
  }
}
</script>

<style scoped>
.header {
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  transition: all 0.3s ease;
  padding: 20px 0;
}

.header.scrolled {
  background-color: rgba(108, 99, 255, 0.9);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  padding: 15px 0;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-text {
  font-size: 22px;
  font-weight: 800;
  color: white;
  letter-spacing: -1px;
}

.nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav li {
  margin-left: 30px;
}

.nav a {
  text-decoration: none;
  color: white;
  font-weight: 500;
  font-size: 16px;
  transition: all 0.3s ease;
  position: relative;
}

.nav a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -5px;
  left: 0;
  background-color: white;
  transition: width 0.3s ease;
}

.nav a:hover::after {
  width: 100%;
}

@media (max-width: 768px) {
  .nav ul {
    gap: 20px;
  }
  
  .nav li {
    margin-left: 15px;
  }
  
  .logo-text {
    font-size: 18px;
  }
}
</style> 